import { render } from "./NotFoundView.vue?vue&type=template&id=73de101c"
const script = {}

import "./NotFoundView.vue?vue&type=style&index=0&id=73de101c&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__